import { render, staticRenderFns } from "./yesTabs.vue?vue&type=template&id=fdc9d55c"
import script from "./yesTabs.vue?vue&type=script&lang=js"
export * from "./yesTabs.vue?vue&type=script&lang=js"
import style0 from "./yesTabs.vue?vue&type=style&index=0&id=fdc9d55c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports